module.exports = __webpack_public_path__ + "img/envelope-front.0e06b0e8.svg";